import React from 'react';
import { useLocation } from 'react-router-dom';

const servicesByPath = {
  '/BuildDocmentation': [
    {
      id: 1,
      icon: 'bi bi-map-fill',
      title: 'As-Built Drawings',
      description: 'The final drawings created after the work is finished are known as as-built drawings. As-built drawings show the built assets precise dimensions and characteristics.',
    },
    {
        id: 2,
        icon: 'bi bi-building',
        title: 'As Built Modeling',
        description: 'An as-built model is a 3D representation of the building structure in its current state. The maintenance and renovations require the use of the as-built models.',
      },
      {
        id: 3,
        icon: 'bi bi-card-checklist',
        title: 'As-built Surveys',
        description: 'To accurately document the location and placement of various components of a construction project. This information is then used to create as-built drawings.',
      },
   
  ],
  '/PointCloudModeling': [
    {
      id: 1,
      icon: 'bi bi-buildings',
      title: 'Laser Scan To BIM',
      description: 'We convert the precise laser scan point cloud data to information rich LOD 500 3D BIM model which can be used for professional design and maintenance of the building.',
    },
    {
        id: 2,
        icon: 'bi bi-check-square-fill',
        title: 'Scan To Revit MEP',
        description: 'We help in creating Mechanical, Electrical, and Plumbing models from point cloud data using Revit for refurbishments in commercial, and industrial buildings.',
      },
      {
        id: 3,
        icon: 'bi bi-cloud-upload-fill',
        title: 'Point Cloud To CAD',
        description: 'We convert point cloud data into editable CAD drawings for residential, commercial, and industrial buildings for professional documentation and design process.',
      },
      {
        id: 4,
        icon: 'bi bi-bank2',
        title: 'Scan to BIM for Heritage Building',
        description: 'We use innovative scan to BIM technology in the documentation and conservation of heritage buildings. Our experts visualize historical structures accurately and plan for future restoration works.',
      },
      {
        id: 5,
        icon: 'bi bi-buildings',
        title: 'Scan to BIM Infrastructure Projects',
        description: 'We use laser scanning to capture precise measurements of physical structures or environments such as roads, bridges or railways. Our engineers ensure quality, minimizing risk throughout project life cycle.',
      },
      {
        id: 6,
        icon: 'bi bi-building-fill-check',
        title: 'Point Cloud to BIM Services for Commercial Projects',
        description: 'Through point cloud to bim conversion, we convert data into BIM Model for design analysis of residential & commercial projects. Point cloud to BIM modeling reduces time & costs of traditional survey.',
      },
    
  ],
  '/IndustrialScanningServices': [
    {
      id: 3,
      icon: 'bi bi-buildings',
      title: 'Industrial Scanning Services',
      description: 'To capture data on existing structures, equipment, utilities',
    },
    // Add other services specific to the '/IndustrialScanningServices' path
  ],
  '/ConstructionScanningServices': [
    {
      id: 1,
      icon: 'bi bi-card-checklist',
      title: 'As Built Survey Existing Site',
      description: 'To verify a buildings metric and geometric data',
    },
    {
        id: 2,
        icon: 'bi bi-building-fill-check',
        title: 'Renovation & Retrofits',
        description: 'To upgrade building systems and technology efficiency',
      },
      {
        id: 3,
        icon: 'bi bi-building-gear',
        title: 'Clash Detection',
        description: 'To identify clashes between multi-trade models',
      },
      {
        id: 4,
        icon: 'bi bi-building-fill-up',
        title: 'New Construction Verification',
        description: 'Inspection, approval and documentation',
      },
      {
        id: 5,
        icon: 'bi bi-map-fill',
        title: 'Planning for Facility Upgrades',
        description: 'To maintain service standards for building occupants',
      },
      {
        id: 6,
        icon: 'bi bi-bounding-box',
        title: 'Prefabrication',
        description: 'Assemblies that are manufactured under factory conditions',
      },
      {
        id: 7,
        icon: 'bi bi-buildings-fill',
        title: 'Construction Coordination',
        description: 'For scheduling and sequencing of projects',
      },
      {
        id: 6,
        icon: 'bi bi-award-fill',
        title: 'Historical Documentation',
        description: 'Information related to the significance of a property',
      },
      {
        id: 7,
        icon: 'bi bi-clock-history',
        title: 'Sequencing, Scheduling & Simulation',
        description: '3D digital model with time or schedule related information.',
      },
   
  ],
  // Add other paths and their corresponding services as needed
};

function InnerServices({ title, paragraph }) {
  const location = useLocation();
  const path = location.pathname;

  const services = servicesByPath[path] || [];

  return (
    <div>
      <section id="services" className="services section-bg">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{title}</h2>
            <p >{paragraph}</p>
          </div>

          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-md-6 mt-4 mt-md-0">
                <div className="icon-box" data-aos="fade-up" data-aos-delay={service.id * 100}>
                  <i className={service.icon}></i>
                  <h4><a href="#">{service.title}</a></h4>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default InnerServices;
